import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { confirmAlert } from 'react-confirm-alert';
import { Tabs, Tab } from 'react-bootstrap';
import _ from 'lodash';
import moment from 'moment';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import BasicRules from './BasicRules/BasicRules';
import ExtendedRules from './ExtendedRules/ExtendedRules';
import LoginRules from './LoginRules/LoginRules';
import ProjectRules from './ProjectRules/ProjectRules';
import TaskRules from './TaskRules/TaskRules';
import DeviationRules from './DeviationRules/DeviationRules';
import TipRules from './TipRules/TipRules';
import DateTimeRules from './DateTimeRules/DateTimeRules';
import DepartmentTypes from './DepartmentTypes/DepartmentTypes';
import Integrations from './Integrations/Integrations';
import ExtraPayments from './ExtraPayments/ExtraPayments';

//elements
import LoadingSpinner from '~/elements/LoadingSpinner';

class ControlPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoad: false,
            isUpdating: false,
        };
    }

    static oldClientData = {};

    static setOldClientData = function (data) {
        ControlPanel.oldClientData = data;
    }

    componentDidMount() {
        this.loadData();
        this.completeSettings();
    }

    componentWillMount() {
        this.props.clientStore.setLoading(true);
    }

    loadData = async () => {
        const { clientStore, userStore, commonStore, t } = this.props;
        const promises = [clientStore.load(userStore.currentUser.client_id, false)]
        await Promise.all(promises).then(result => {
            const res = result[0];
            this.setState(prevState => ({ isLoad: !prevState.isLoad }));
            const mergedClientData = { ...res.client.data, integration_details: res.client.integration_details || {} };
            ControlPanel.setOldClientData(mergedClientData);
        }).catch(err => {
            console.error(err)
            commonStore.addNotification(t('Something went wrong!'), null, 'error');
        })
    }

    saveClientsConfig = (hasUpdatedWeekendsPayment) => {
        const { clientStore, commonStore, t } = this.props;
        const currentClient = Object.assign({}, clientStore.currentEntity.client);
        currentClient.data.isFirstTimeLogin = false;
        currentClient.hasUpdatedWeekendsPayment = hasUpdatedWeekendsPayment;
        return clientStore.save(currentClient, false).then((result) => {
            if (!result.client || !result.client.id) {
                commonStore.addNotification(t('Something went wrong!'), null, 'error');
                this.setState({ isUpdating: false });
                return false;
            }
            const mergedClientData = {
                ...result.client.data,
                integration_details: result.client.integration_details || clientStore.currentEntity.client.integration_details || {}
            };
            ControlPanel.setOldClientData(mergedClientData);
            commonStore.setAppLoaded(false).then((res) => {
                commonStore.addNotification(t('Saved'), null, 'success');
                this.setState({ isUpdating: false });
                this.props.router.navigate('/admin');
                return true;
            })

        }).catch(err => {
            console.error({ err });
            clientStore.resetClientData(ControlPanel.oldClientData);
            this.setState({ isUpdating: false });
        });
    }

    handleSubmitEvent = async (isIntegrationAutoSave = false) => {
        const { clientStore, commonStore, t } = this.props;
        const { data: newClientData } = clientStore?.currentEntity?.client || {};
        const { workPlanSettings } = newClientData.basicRules || {};
        const { Vacation_setup } = newClientData || {};
        const { collectiveAgreementLeaveDays, socialWelfareLeaveHours, medicalLeaveDaysForEmployer, medicalLeaveNewPeriodThresholdDays } = newClientData.basicRules || {};

        if (workPlanSettings) {
            if (workPlanSettings?.lockInPeriodForUnionApproval < 4) {
                commonStore.addNotification(t('Minimum value for Lock in period for union approval can not be less than 4 days'), null, 'error');
                return;
            }
            // if (workPlanSettings?.lockInPeriodForPublish < 2) {
            //     commonStore.addNotification(t('Minimum value for Lock in period for publish can not be less than 2 days'), null, 'error');
            //     return;
            // }
            // if (workPlanSettings?.lockInPeriodEditPublishedShift < 3) {
            //     commonStore.addNotification(t('Minimum value for Lock in period edit published shift can not be less than 3 days'), null, 'error');
            //     return;
            // }
        }

        if (Vacation_setup) {
            if (!Vacation_setup.eligible_age_for_extra_vacations || Number(Vacation_setup.eligible_age_for_extra_vacations) < 50) {
                commonStore.addNotification(t('Minimum age for extra vacations is 50'), null, 'error');
                return;
            }
            if (!Vacation_setup.eligible_age_for_extra_vacations || Number(Vacation_setup.extra_vacation_days) < 0) {
                commonStore.addNotification(t('Extra vacation days should be positive'), null, 'error');
                return;
            }
        }

        if (medicalLeaveDaysForEmployer != null && (Number(medicalLeaveDaysForEmployer) < 1 || Number(medicalLeaveDaysForEmployer) > 100)) {
            commonStore.addNotification(t('Employer medical leave period must be between 1 and 100 days'), null, 'error');
            return;
        }

        if (medicalLeaveNewPeriodThresholdDays != null && (Number(medicalLeaveNewPeriodThresholdDays) < 1 || Number(medicalLeaveNewPeriodThresholdDays) > 100)) {
            commonStore.addNotification(t('New employer medical leave period threshold must be between 1 and 100 days'), null, 'error');
            return;
        }

        if (clientStore.validateClientRuleChangeResponse?.collectiveAgreement?.maxCollectiveAgreementLeaveDaysUsed > collectiveAgreementLeaveDays) {
            return commonStore.addNotification(t('Collective agreement leave days can not be less than used days' + ' ' + clientStore.validateClientRuleChangeResponse?.collectiveAgreement?.maxCollectiveAgreementLeaveDaysUsed), null, 'error', 'top-right', 3000);
        }

        if (clientStore.validateClientRuleChangeResponse?.socialWelfare?.maxSocialWelfareHoursUsed > socialWelfareLeaveHours) {
            return commonStore.addNotification(t('Social welfare leave hours can not be less than used hours' + ' ' + clientStore.validateClientRuleChangeResponse?.socialWelfare?.maxSocialWelfareHoursUsed), null, 'error', 'top-right', 3000);
        }
        const shouldStopSubmission = await this.checkIntegrationSettingsAndSubmit(isIntegrationAutoSave);
        if (shouldStopSubmission) return;
        this.setState({ isUpdating: true })
        this.submitForm();
    }

    syncDataAfterIntegrationSettingSave = () => {
        const { clientStore } = this.props;
        const res = clientStore.currentEntity;
        const mergedClientData = { ...res.client.data, integration_details: res.client.integration_details || {} };
        ControlPanel.setOldClientData(mergedClientData);
    }

    saveIntegrationSettingsHandler = async (currentSubset) => {
        const { clientStore, commonStore, t } = this.props;

        try {
            this.setState({ isUpdating: true });
            const clientId = clientStore.currentEntity.client.id;
            const data = { integrationSettings: currentSubset };

            const response = await clientStore.saveIntegrationSettings(clientId, data);
            commonStore.addNotification(t(response.message), null, 'success');

            if (ControlPanel.oldClientData.integration_details) {
                ControlPanel.oldClientData.integration_details.integration_settings = {
                    ...ControlPanel.oldClientData.integration_details.integration_settings,
                    ...currentSubset
                };
            }
            return true;
        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Error saving integration settings'), null, 'error');
            this.setState({ isUpdating: false });
            return false;
        }
    }

    checkIntegrationSettingsAndSubmit = async (isAutoSave = false) => {
        const { clientStore, t } = this.props;
        const currentSettings = clientStore.currentEntity?.client?.integration_details?.integration_settings || {};
        const oldSettings = ControlPanel.oldClientData?.integration_details?.integration_settings || {};

        if (!_.isEqual(currentSettings, oldSettings)) {

            if (isAutoSave) {
                const success = await this.saveIntegrationSettingsHandler(currentSettings);
                return !success;
            }

            confirmAlert({
                title: `${t('Save')} ${t('Payroll Integration')} ${t('Settings')}?`,
                message: t('You have unsaved changes in the Integration Settings. Would you like to save them?'),
                buttons: [
                    {
                        label: t('Yes'),
                        onClick: async () => {
                            const success = await this.saveIntegrationSettingsHandler(currentSettings);
                            if (success) this.submitForm();
                        }
                    },
                    {
                        label: t('No'),
                        onClick: () => {
                            this.setState({ isUpdating: true });
                            this.submitForm();
                        }
                    },
                    {
                        label: t('Cancel'),
                        onClick: () => { }
                    }
                ]
            });
            return true;
        }
        return false;
    }

    submitForm() {
        const { clientStore, t } = this.props;

        if (clientStore.currentEntity.client?.data?.extraPayments[0]?.amount !== ControlPanel.oldClientData.extraPayments[0]?.amount) {
            confirmAlert({
                title: this.props.t('Are you sure you want to update this') + '' + '?',
                message: t("By adjusting an additional percentage for weekends, the weekend extra percentage for all members will be updated"),
                buttons: [
                    {
                        label: this.props.t('Yes'),
                        onClick: () => {
                            this.saveClientsConfig(true);
                        },
                    },
                    {
                        label: this.props.t('No'),
                        onClick: () => {
                            clientStore.currentEntity.client.data.extraPayments[0].amount = ControlPanel.oldClientData.extraPayments[0]?.amount
                            this.saveClientsConfig(false);
                        },
                    },
                ],
            });
        }
        else {
            this.saveClientsConfig(false);
        }
    }

    completeSettings() {
        const { commonStore, t } = this.props;
        if (commonStore.config.client.data.isFirstTimeLogin) {
            return commonStore.addNotification(t('Please complete settings'), null, 'success');
        }
    }

    checkForUnsavedChanges(cb) {
        const { clientStore, t } = this.props;
        const currentIntegrationDetails = clientStore.currentEntity.client.integration_details || {};
        const mergedCurrentData = {
            ...clientStore.currentEntity.client.data,
            integration_details: currentIntegrationDetails
        };
        const newData = JSON.parse(JSON.stringify(mergedCurrentData));
        if (!_.isEqual(newData, ControlPanel.oldClientData)) {
            confirmAlert({
                title: t('Do you want to save the changes') + '?',
                message: t("Changes are not saved yet and hence won't reflect, do you wish to save them") + '?',
                buttons: [
                    {
                        label: t('Save'),
                        onClick: () => {
                            this.handleSubmitEvent(true);
                        },
                    },
                    {
                        label: t('Discard'),
                        onClick: () => {
                            this.props.clientStore.resetClientData(ControlPanel.oldClientData);
                            if (cb) cb();
                        },
                    },
                ],
            });
        } else {
            if (cb) cb();
        }
    }

    onCancel() {
        const cb = () => this.props.router.navigate('/admin');
        this.checkForUnsavedChanges(cb);
    }

    componentWillUnmount() {
        this.checkForUnsavedChanges(null);
    }

    render() {
        const { t, clientStore } = this.props;
        const { isLoad, isUpdating } = this.state;
        const allowTip = clientStore.currentEntity.client ? clientStore.currentEntity.client.allow_tip : '';
        return (
            <div className="control-panel">
                {isUpdating ?
                    <LoadingSpinner /> :
                    <>
                        <Tabs defaultActiveKey="dateTimeRules" id="MainTabContainer">
                            <Tab eventKey="dateTimeRules" title={t('Regional Settings')}>
                                <h5 className='fw-600'>{t('Regional Settings')}</h5>
                                {isLoad && <DateTimeRules />}
                            </Tab>
                            <Tab eventKey="basicRules" title={t('Basic Rules')}>
                                <h5 className='fw-600'>{t('Basic Rules')}</h5>
                                {isLoad && <BasicRules />}
                            </Tab>
                            <Tab eventKey="extendedRules" title={t('Extended rules')}>
                                <h5 className='fw-600'>{t('Extended rules')}</h5>
                                {isLoad && <ExtendedRules />}
                            </Tab>
                            <Tab eventKey="projectRules" title={t('Project Rules')}>
                                <h5 className='fw-600'>{t('Project Rules')}</h5>
                                {isLoad && <ProjectRules />}
                            </Tab>
                            <Tab eventKey="Task Rules" title={t('Task Rules')}>
                                <h5 className='fw-600'>{t('Task Rules')}</h5>
                                {isLoad && <TaskRules />}
                            </Tab>
                            <Tab eventKey="deviationRules" title={t('Deviation Rules')}>
                                {isLoad && <DeviationRules />}
                            </Tab>
                            <Tab eventKey="loginRules" title={t('Login Rules')}>
                                {isLoad && <LoginRules />}
                            </Tab>
                            <Tab eventKey="departmentTypes" title={t('Departments')}>
                                {isLoad && <DepartmentTypes />}
                            </Tab>
                            <Tab eventKey="integrations" title={t('Integrations')}>
                                {isLoad && <Integrations onSaveSuccess={this.syncDataAfterIntegrationSettingSave} />}
                            </Tab>
                            <Tab eventKey="extraPayments" title={t('Additional Payments')}>
                                {isLoad && <ExtraPayments />}
                            </Tab>
                            {allowTip &&
                                <Tab eventKey="tipRules" title={t("Tip Rules")}>
                                    <h5 className='fw-600'>{t('Tip Rules')}</h5>
                                    {isLoad && allowTip && <TipRules />}
                                </Tab>
                            }
                        </Tabs>
                        <button className="btn btn-fill" onClick={() => this.handleSubmitEvent(false)}>
                            {t('Submit')}
                        </button>
                        <button className="btn" style={{ marginLeft: '2rem' }} onClick={() => this.onCancel()}>
                            {t('Cancel')}
                        </button>
                    </>
                }
            </div>
        );
    }
}

export default inject('clientStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(ControlPanel))));
